import { runOverlayResetHandlers } from '../../shared/ports/sessionResetPort';

let resetShellFn: (() => void) | null = null;

/** Registra el handler de reset de shell (evita import circular con shellNavigationReset). */
export function bindResetShellStack(fn: () => void): void {
  resetShellFn = fn;
}

export function shouldRunBranchChangeSideEffects(
  previousBranchId: string | undefined,
  nextBranchId: string | undefined,
): boolean {
  return previousBranchId !== nextBranchId;
}

export function resolveBranchIdAfterListUpdate(
  previousBranchId: string | undefined,
  branches: Array<{ id: string }>,
): string | undefined {
  return previousBranchId && branches.some((branch) => branch.id === previousBranchId)
    ? previousBranchId
    : undefined;
}

/** Cierra overlays/modales globales (p. ej. logout o cambio de sucursal). */
export function resetAllModuleOverlays(): void {
  runOverlayResetHandlers();
}

export type BranchChangeSideEffectOptions = {
  /**
   * Default true. Si false, limpia overlays/carrito pero no resetea el shell a MainTabs
   * (p. ej. Editar sucursal B desde Gestionar sin perder la navegación a BranchIdentity).
   */
  resetShell?: boolean;
};

/** Limpia carrito, overlays y (opcional) stack del shell tras un cambio efectivo de sucursal. */
export function applyBranchChangeSideEffects(options?: BranchChangeSideEffectOptions): void {
  resetAllModuleOverlays();
  if (options?.resetShell === false) return;
  if (resetShellFn) resetShellFn();
}
